import React from 'react';
import classNames from 'classnames';
import Content from '@/components/foundations/content';
import { StaticImage } from 'gatsby-plugin-image';
import * as styles from './output.module.scss';

const OutputContent: React.FC<{modal: Function}> = ({modal}) => {
  const firstImage = (
    <figure>
      <StaticImage src="./img/Sample01.png" alt="" objectFit="contain" />
    </figure>
  )

  const secondImage = (
    <figure>
      <StaticImage src="./img/Sample02.png" alt="" objectFit="contain" />
    </figure>
  )

  return (
    <>
      <h2>
        <span>
          <strong>Output</strong>
          <small>成果物サンプル</small>
        </span>
      </h2>
      <h3>
        <span>成果物のサンプルイメージです。レビュー対象のプロダクトやサービスにあわせて最適な内容に調整いたします。</span>
      </h3>

      <ul>
        <li>
          <p>評価レポートサンプル</p>
          <a onClick={() => {modal(firstImage);}} href="javascript:void(0);">{firstImage}</a>
        </li>
        <li>
          <p>設計方針サンプル</p>
          <a onClick={() => {modal(secondImage);}} href="javascript:void(0);">{secondImage}</a>
        </li>
      </ul>
    </>
  );
};

const Output: React.FC<{modal: Function}> = ({modal}) => {
  return (
    <Content
      className={{ wrapper: styles.pOutput, inner: styles.lContent__inner }}
      intersection={{ visible: styles.visible, standby: styles.standby, threshold: 0.3 }}
    >
      <OutputContent modal={modal} />
    </Content>
  );
};

export default Output;
